import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Plane } from "lucide-react";

const TOP_AIRPORTS = [
  { code: "ATL", name: "Hartsfield-Jackson Atlanta" },
  { code: "LAX", name: "Los Angeles International" },
  { code: "ORD", name: "Chicago O'Hare International" },
  { code: "DFW", name: "Dallas/Fort Worth International" },
  { code: "JFK", name: "John F. Kennedy International" },
  { code: "LGA", name: "LaGuardia" },
  { code: "LAS", name: "Harry Reid International" },
  { code: "MIA", name: "Miami International" },
];

interface PopularAirportsProps {
  currentCode: string;
}

export const PopularAirports = ({ currentCode }: PopularAirportsProps) => {
  const filtered = TOP_AIRPORTS.filter(a => a.code !== currentCode.toUpperCase());

  return (
    <Card>
      <CardContent className="pt-6">
        <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
          <Plane className="h-5 w-5 text-primary" />
          Popular Airports
        </h2>
        <div className="grid sm:grid-cols-2 gap-2">
          {filtered.map((airport) => (
            <Link
              key={airport.code}
              to={`/airports/${airport.code.toLowerCase()}`}
              className="flex items-center gap-2 p-3 rounded-lg border border-border hover:border-primary/40 hover:bg-primary/5 transition-colors group"
            >
              <span className="font-bold text-primary text-sm">{airport.code}</span>
              <span className="text-sm text-muted-foreground group-hover:text-foreground transition-colors">
                {airport.name} ({airport.code}) TSA Times
              </span>
            </Link>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
